<mat-expansion-panel
  [hideToggle]="hideToggle"
  [expanded]="expanded ? (expandable ? true : false) : false"
  [disabled]="!expandable"
  #panel
>
  <mat-expansion-panel-header [class]="display === 'custom' ? '' : 'pal'">
    <div
      class="d-flex align-items-center justify-content-space-between gap-s full-w"
    >
      <ng-content select="[header]"></ng-content>
      <div
        class="d-flex align-items-center justify-content-space-between gap-m"
      >
        @if (tooltip) {
          <pr-tooltip-icon [tooltip]="tooltip"></pr-tooltip-icon>
        }
        @if (expandable) {
          <pr-icon
            name="expand_more"
            [width]="24"
            [class.rot180]="panel.expanded"
          ></pr-icon>
        }
        @if (!expandable && !redirect) {
          <pr-icon
            class="notExpandable"
            name="expand_more"
            [width]="24"
          ></pr-icon>
        }
        @if (redirect && !expandable) {
          <pr-icon class="redirect" name="arrow_forward" [width]="24"></pr-icon>
        }
      </div>
    </div>
  </mat-expansion-panel-header>
  <ng-content select="[body]"></ng-content>
</mat-expansion-panel>
